import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section id="top" className="flex min-h-[calc(100svh-3.75rem)] bg-brand-main px-4 py-7 text-center sm:py-8" data-id="element-85" data-mp="2hvm4m8t8rmbp">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.58
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center justify-center" data-id="element-86" data-mp="23wmhx6pahhi6">
        <p className="mb-2 text-[10px] font-extrabold tracking-[0.2em] text-brand-teal sm:text-xs" data-id="element-87" data-mp="30lauhni8kck7">
          THE COMPLETE MATH CURRICULUM
        </p>
        <h1 className="mx-auto max-w-5xl text-[2.15rem] font-black leading-[1.04] tracking-tight text-brand-blue sm:text-[3.4rem] md:text-[3.75rem]" data-id="element-88" data-mp="2mt4go82k2hnx">
          Teach a Full Year of <span className="italic text-brand-purple" data-id="element-89" data-mp="3fi1kj660sbx5">Math</span> in Just 5 Minutes of Prep
        </h1>
        <p className="mx-auto mt-3 max-w-4xl text-sm leading-relaxed text-brand-gray sm:text-base md:text-lg" data-id="element-90" data-mp="3k9jm9wfvagj6">
          Math Ready is a complete, done-for-you math curriculum — 10 ready-to-teach volumes packed with theory, worked
          examples, step-by-step practice, and assessments, from Grade 1 to Grade 10. Just print, open, and teach.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/w7vxP2ueaaMRgc6kXXKji4/ChatGPT_Image_4_ago_2026,_13_28_32.png" alt="Math Ready curriculum bundle with ten printable math workbooks, digital teaching materials, and five bonuses" className="mx-auto my-2 h-[37svh] w-auto max-w-full object-contain sm:my-3 sm:h-[40svh] md:h-[43svh]" data-id="element-91" data-mp="2p7eizu5pq86e" />
        <div className="flex w-full flex-col items-center" data-id="element-92" data-mp="383nz0n06d8t1">
          <CTAButton className="min-w-[204px] px-4 py-2 text-[9px] shadow-sm sm:min-w-[224px] sm:px-5 sm:py-2.5 sm:text-[10px]" data-id="element-93" data-mp="334kzfi2yrusg">
            GET THE MATH READY PACK
          </CTAButton>
          <p className="mt-2 max-w-xl text-center text-[9px] font-semibold leading-relaxed text-brand-gray sm:text-[10px]" data-id="element-94" data-mp="18rbpxqaf49a7">
            ✓ Instant digital download <span className="px-1 text-brand-orange" data-id="element-95" data-mp="38uw6tmm3hzoh">·</span> ✓ Works for Grades 1–10{' '}
            <span className="px-1 text-brand-orange" data-id="element-96" data-mp="3dsxy2utod5b1">·</span> ✓ Aligned to Common Core
          </p>
        </div>
      </motion.div>
    </section>;
}